module.exports = "https://static.moomoo.com/components/top-trading-signals/images/sticky_tabs_active_bg.97ba38f7ff.png";